"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const HasMinNumberOfElementsValidator_1 = require("./HasMinNumberOfElementsValidator");
const HasMaxNumberOfElementsValidator_1 = require("./HasMaxNumberOfElementsValidator");
class HasMinMaxNumberOfElementsValidator {
    constructor(minElementCount, maxElementCount) {
        this.minValidator = new HasMinNumberOfElementsValidator_1.HasMinNumberOfElementsValidator(minElementCount);
        this.maxValidator = new HasMaxNumberOfElementsValidator_1.HasMaxNumberOfElementsValidator(maxElementCount);
    }
    isValid(input) {
        return this.minValidator.isValid(input) && this.maxValidator.isValid(input);
    }
}
exports.HasMinMaxNumberOfElementsValidator = HasMinMaxNumberOfElementsValidator;
//# sourceMappingURL=HasMinMaxNumberOfElementsValidator.js.map